import './QRCodeScan.less';

export const prefix = 'bm-c-qrcode-scan';

export { default } from './QRCodeScan';
